<!-- <p>virtual-sensors works!</p> -->
<div class="main-vs">
    <span *ngIf="virtualSensor" class="title">Virtual DataPoint: {{virtualSensor.VirtualSensorName}}</span>
    <div class="virtual-sensor-details">
        <span>Input DataPoints: </span>
        <span *ngFor="let datapoint of inputDataPoints; let idx = index">
            {{idx != 0 ? ', ' : ''}}{{datapoint.DPTitle}}
        </span>
    </div>
</div>